import React, { ChangeEventHandler, FunctionComponent } from 'react';
import './imageUpload.scss';
import ProfileIcon from '../icons/ProfileIcon';
import Typography from '../typography/Typography';

type ImageUploadProps = {
  onChange: ChangeEventHandler;
  photo?: string;
  className?: string;
  title?: string;
  alt?: string;
  existingPhotoText?: string;
  newPhotoText?: string;
}

const ImageUpload: FunctionComponent<ImageUploadProps> = ({
  onChange,
  photo = '',
  className = '',
  title = 'Your profile picture',
  alt = 'Driver',
  existingPhotoText = 'Change photo',
  newPhotoText = 'Upload a photo',
}) => (
  <div datatest-id="image-upload" className={`d-flex flex-column ${className}`}>
    <Typography
      variant="caption"
      className="d-block photoText"
      color="asphalt6"
    >
      { title }
    </Typography>
    <div className="image-upload-component margin-top-20">
      {photo ? (
        <img
          className="image-upload-avatar"
          alt={alt}
          src={photo}
        />
      ) : (
        <div className="placeholder-container">
          <ProfileIcon width={50} color="asphalt7" />
        </div>
      )}

      <label data-testid="button_change-photo" htmlFor="image-upload-input">
        <span>
          { photo ? existingPhotoText : newPhotoText }
        </span>
      </label>
      <input
        id="image-upload-input"
        className="image-upload-input"
        type="file"
        onChange={onChange}
      />
    </div>
  </div>
);

export default ImageUpload;
